import { PricesStateInterface } from '.';

function state(): PricesStateInterface {
  return {
    prices: [],
  };
}

export default state;
